import React, { useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import HowToMonitor from "./HowToMonitor";
import ConnectTheService from "./ConnectTheService";
import SmsDropdown from "./SmsDropdown";
import EmailDropdown from "./EmailDropdown";
import HTTPSWebDropdown from "./HTTPSWebDropdown";
import SourceAddressAndAuthentication from "./SourceAddressAndAuthentication";
import AddAddress from "./AddAddress";
import WeatherAlert from "../WeatherAlerts/WeatherAlert";
import { Pin } from "@vis.gl/react-google-maps";
import PingMethod from "./PingMethod";
import SelectApiConnection from "./SelectApiConnection";
import ApiConnection from "../Common/DataImportModal/ApiConnection";
import HelpButton from "../HelpContent/HelpButton";

function MonitoringConfigure({
  monitor,
  setMonitor,
  backendErrors,
  setSelectedApiDetails,
  method,
  setMethod,
}) {
  return (
    <div>
      <Row className="mt-3">
        <Col xl={5} xs={12} className="border-end">
          <div className="me-xl-5 mb-2 mb-xl-0">
            {monitor.Kind === "heartbeat" && (
              <ConnectTheService
                howtoService={monitor.howtoService}
                setHowtoService={(value) => {
                  setMonitor({ ...monitor, howtoService: value });
                }}
              />
            )}
            {monitor.Kind === "alert" && (
              <ConnectTheService
                howtoService={monitor.howtoService}
                setHowtoService={(value) => {
                  setMonitor({ ...monitor, howtoService: value });
                }}
              />
            )}
            {monitor.Kind === "ping" && (
              <PingMethod
                method={method}
                setMethod={(newMethod) => {
                  if (newMethod === "createANewApi") {
                    setMonitor({
                      ...monitor,
                      ApiConnectionUuid: null,
                      ApiConnection: {
                        Status: "production",
                        Label: monitor.Label + " API Connection",
                        Kind: "third-party",
                        Profile: {
                          BaseUrl: "http://api:9090",
                          AuthHeader: "Authorization",
                          AuthValue: "Basic <base64encryptedstring>",
                          AuthKind: "",
                          Timeout: 1,
                          DefaultMethod: "GET",
                          ContentType: "JSON",
                          QueryParams: null,
                          FormData: null,
                          JsonPayload: null,
                          JsonPayloadTokens: null,
                          ComponentConfig: null,
                          JsonApiDataCollections: null,
                        },
                      },
                    });
                  }
                  if (newMethod === "selectAnApi") {
                    setMonitor({
                      ...monitor,
                      ApiConnectionUuid: null,
                      ApiConnection: null,
                    });
                  }

                  setMethod(newMethod);
                }}
              />
            )}
            {backendErrors?.["Monitor.ApiConnection"] && (
              <div className="alert alert-danger p-1 mt-2">
                {backendErrors?.["Monitor.ApiConnection"]}
              </div>
            )}
          </div>
        </Col>
        <Col xl={7}>
          <div className="ms-xl-5 mt-xl-2">
            {["heartbeat", "alert"].includes(monitor.Kind) && (
              <div className="mx-auto ">
                {monitor.howtoService?.name === "sms" && <SmsDropdown />}
                {monitor.howtoService?.name === "email" && <EmailDropdown />}
                {monitor.howtoService?.name === "httpsAPI" && (
                  <HTTPSWebDropdown />
                )}
                {["sms", "email", "httpsAPI"].includes(
                  monitor.howtoService?.name
                ) && (
                  <div className="my-3">
                    <SourceAddressAndAuthentication />
                    <AddAddress />
                  </div>
                )}
                {["voice", "other"].includes(monitor.howtoService?.name) && (
                  <div className="my-3"></div>
                )}
              </div>
            )}
          </div>

          {method === "selectAnApi" && (
            <div className="ms-xl-5">
              <SelectApiConnection
                selected={monitor.ApiConnectionUuid}
                onSelect={(api) => {
                  setSelectedApiDetails(api);
                  setMonitor({
                    ...monitor,
                    ApiConnectionUuid: api?.Uuid,
                  });
                }}
              />
            </div>
          )}
          {method === "createANewApi" && (
            <div className="ms-xl-5 bg-purple-gradient-darker-reverse rounded-4 p-4 px-5 ">
              <h5>
                Create a New API Connection
                <HelpButton helpKey="create-api-connection" />
              </h5>

              <ApiConnection
                hideAdvanced
                api={monitor.ApiConnection?.Profile}
                onChange={(Profile) => {
                  const apiConnection = {
                    Status: "production",
                    Kind: "third-party",
                    Label: monitor.Label + " API Connection",
                    Profile,
                  };
                  setSelectedApiDetails(apiConnection);
                  setMonitor({
                    ...monitor,
                    ApiConnection: apiConnection,
                  });
                }}
              />
            </div>
          )}
        </Col>
      </Row>
      <Row className="mx-xl-5 mt-3">
        {monitor.whatToMonitor?.name === "weather" && (
          <Col xl={7}>
            <WeatherAlert />
          </Col>
        )}
      </Row>
    </div>
  );
}

export default MonitoringConfigure;
